import { Component, Input, ViewEncapsulation, ContentChildren, QueryList, ContentChild } from '@angular/core';

import { PuiButtonType } from './button-config';
import { PuiMenuItemComponent } from '../menu/menu.component';
import { PuiButtonDropDownDirective } from './button-dropdown.directive';

const isCircle = (type: PuiButtonType) => [PuiButtonType.Icon, PuiButtonType.Portlet].indexOf(type) >= 0;
const isOutlineBtn = (type: PuiButtonType) => [PuiButtonType.Primary, PuiButtonType.Submit, PuiButtonType.Link].indexOf(type) === -1;
@Component({
  selector: 'pui-button',
  templateUrl: 'button.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PuiButtonComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() color: string;
  @Input() disabled = false;
  @Input() set type(state: PuiButtonType) {
    this.buttonType = state;
    switch (state) {
      case PuiButtonType.Link:
        this.buttonStyle = PuiButtonType.Link;
        break;
      case PuiButtonType.Primary:
      case PuiButtonType.Submit:
        this.buttonStyle = PuiButtonType.Primary;
        break;
      default:
        this.buttonStyle = PuiButtonType.Normal;
    }
  }
  get type(): PuiButtonType {
    return this.buttonType;
  }

  get btnType(): string {
    return this.buttonType === PuiButtonType.Submit ? 'submit' : 'button';
  }

  @ContentChild(PuiButtonDropDownDirective) dropdown: PuiButtonDropDownDirective;
  @ContentChildren(PuiMenuItemComponent) menus: QueryList<PuiMenuItemComponent>;

  private buttonType: PuiButtonType = PuiButtonType.Normal;
  private buttonStyle: PuiButtonType = PuiButtonType.Normal;

  isIconType(): boolean {
    return this.type === PuiButtonType.Icon;
  }

  getClasses() {
    let classes = {
      'btn': true,
      'btn-outline': isOutlineBtn(this.type),
      'pui-btn': true,
      [`btn-${this.buttonStyle}`]: true,
      'btn-icon-only': this.type === PuiButtonType.Icon,
      'btn-circle': isCircle(this.type)
    };
    Object.assign(classes, {
      [this.color || 'blue']: !!this.color || (this.buttonStyle !== PuiButtonType.Link)
    });
    return classes;
  }
}

@Component({
  selector: 'pui-button-group',
  template: `
    <div [ngClass]="_buttonGroupClass()">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: [`./button.component.scss`],
  encapsulation: ViewEncapsulation.None
})
export class PuiButtonGroupComponent {
  @Input() vertical: boolean;
  @Input() type = PuiButtonType.Normal;

  @ContentChildren(PuiButtonComponent) buttons: QueryList<PuiButtonComponent>;

  _buttonGroupClass() {
    return {
      'btn-group': !this.vertical,
      'btn-group-vertical': this.vertical,
      'btn-group-circle': isCircle(this.type) && !this.vertical,
      'btn-group-vertical-circle': isCircle(this.type) && this.vertical
    };
  }
}
